var path = 'event/event-header-error.tpl.html';
var html = "\n<div translate class=\"tb-cell\" flex=\"30\">event.event-time</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.server</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.method</div>\n<div translate class=\"tb-cell\" flex=\"20\">event.error</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-error.tpl.html
// module id = 1481
// module chunks = 1